import { BuildingCircularSiteMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const List = [
  {
    fileStoreId: "a3a5a592-9a58-4ee8-9476-8509411098d1",
    label: "DG(BLDG)'s Circular No. 6 of 2016-17",
    date: "	02/01/2017",
    subject:
      "Amended guideline for sanction of building plan for the premises located adjacent to defence extablishments (10 meter) Military 10 meter Circular No. 6 of 2016-17",
  },
  {
    fileStoreId: "8bb9cd58-9381-4337-a555-c1a173777a16",
    label: "DG(BLDG)'s Circular No. 5 of 2016-17",
    date: "14/12/2016",
    subject:
      "Application of Circular 9 in uc matters Circular No. 5 of 2016-17",
  },
  {
    fileStoreId: "26e3a240-fc62-460d-b083-8f4c5fc95174",
    label: "DG(BLDG)'s Circular No. 4 of 2016-17",
    date: "09/09/2016",
    subject: "Green building stamp Circular No. 4 of 2015-16",
  },
  {
    fileStoreId: "8bd52ab4-25f0-4f18-8e64-389bc7401e37",
    label: "DG(BLDG)'s Circular No. 3 of 2016-17",
    date: "09/08/2016",
    subject:
      "Concent to Establish to be submitted with Commencement notice Circular No. 3 of 2016-17",
  },
];

const Building_Sanction_Circular_2016_17 = () => (
  <TableStructure
    list={List}
    columnNo={3}
    leftMenuList={BuildingCircularSiteMenuList}
    title="Circular :: 2016-17"
    longMenuList={true}
  />
);

export default Building_Sanction_Circular_2016_17;
